 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"CompareSymbols":"CompareSymbols","CongratsInvestment":"CongratsInvestment","DiscoverDetailBasket":"DiscoverDetailBasket","Home":"Home","Index":"Index","IndexLogin":"IndexLogin","Login":"Login","MarketAnalysis":"MarketAnalysis","MarketOverview":"MarketOverview","Profile":"Profile","Recover":"Recover","TradeIdeas":"TradeIdeas"}[chunkId]||chunkId) + "." + {"CompareSymbols":"6018e575","CongratsInvestment":"cd512dd1","DiscoverDetailBasket":"0b90cf6b","Home":"cb049f77","Index":"710e4826","IndexLogin":"f6a77cc4","Login":"1a858b07","MarketAnalysis":"9ac45c78","MarketOverview":"9af6ddd4","Profile":"5f1dc35a","Recover":"b22170e0","TradeIdeas":"30d9fcf8","chunk-04ccef1c":"b624afa1","chunk-0b0b95f7":"8b145450","chunk-1a600e35":"4dd11a70","chunk-21b8d064":"0c1b346c","chunk-2d0a3c21":"a483a56f","chunk-2d0b1c46":"4a275445","chunk-2d0b304c":"8cf5b029","chunk-2d0b64c7":"4b7ea48f","chunk-2d0c91f1":"161a705b","chunk-2d0d7303":"12456e25","chunk-2d0dd5e3":"10944e95","chunk-2d0e526b":"14f29406","chunk-2d0e93b3":"84c08a08","chunk-2d20f359":"8965222f","chunk-59520b17":"0ac1777d","chunk-2d20ff36":"d57a8074","chunk-2d210494":"a6cdd9c3","chunk-2d217716":"fe60439b","chunk-2d228e7f":"8970c1dd","chunk-3c45ce75":"8f0258bb","chunk-3d8f3f65":"90c2ddeb","chunk-465b2b0d":"8d4d3d47","chunk-471aa7ba":"997aeed8","chunk-4eab4b4a":"9376f2b9","chunk-17888276":"45874f74","chunk-503649a8":"8175826c","chunk-3bca3622":"86cca20e","chunk-4f76de22":"2180e3eb","chunk-5d8e37f8":"4aeb9504","chunk-5e6f1162":"80e40bb0","chunk-63bb3991":"0f48d38c","chunk-6696b11c":"eb1d4a77","chunk-6fc74062":"7ea8af99","chunk-7492dbc2":"7cbfc2de","chunk-7730d40d":"d836d966","chunk-a2e7685c":"21fa0483","chunk-adf9cb26":"f330acce","chunk-ccbb9b8a":"7aa8be47","chunk-cf4bb164":"86037a83","chunk-d93d346a":"7ef6bb01","chunk-2d2288e0":"25e6b4ab","chunk-2d230a55":"d3409101","chunk-065ce104":"9b78fcc1","chunk-0b551944":"006e8759","chunk-2d0a4838":"66d27923","chunk-2d21a700":"dfd5edca","chunk-46123b5d":"d565e745","chunk-4815502d":"89cd77ac","chunk-ad71da00":"8a727aff","chunk-f6879e22":"6a29c347","chunk-031ae681":"60ef78e4","chunk-2d0c1d2c":"ea12585d","chunk-2d0cbe2b":"9af8de69","chunk-2d21d838":"82f576ea","chunk-02ed9f8e":"53af9e50","chunk-7cfa743a":"2a0ea259","chunk-f328d256":"1823cad2","chunk-2d225840":"c5b9a3e4","chunk-9429c060":"b9568e27","chunk-0c44d57d":"3f006707","chunk-216771a3":"7961805a","chunk-2d0ab119":"48fa6cb2","chunk-2d0b9672":"1eee58eb","chunk-44343ce1":"d3c2cd70","chunk-2d21d445":"90c51138","chunk-2d21f28d":"ecc9829b","chunk-35f93194":"3410aff9","chunk-12e41089":"f6c41781","chunk-74f8bd2e":"792b79ed","chunk-7a900412":"e4131189","chunk-7c22f149":"e0aef2cd","chunk-9f17c368":"5ec205f8","chunk-e5267ff6":"d89fcca2","chunk-2f0ab176":"9fccc7bb","chunk-edcea1fa":"38b42cc2","chunk-f0151272":"b69c321b","chunk-2d0c4c81":"69397bca","chunk-2d238059":"adb8d608","chunk-cbbc61f4":"cd3e9440","chunk-72e93578":"ede24665","chunk-cad577a0":"c8e18d3f","chunk-2d0b9454":"1f8bc37f","chunk-2d0bce02":"ab2c0535","chunk-16d8b95f":"cf89885f","chunk-26e6e08c":"e800ac99","chunk-749927d4":"9f8076b3","chunk-19102138":"a31176e2","chunk-56111365":"dcdfe47e","chunk-005088aa":"cc59446b","chunk-134d399e":"c1f6e966","chunk-2d0b30e9":"96d584c5","chunk-2d224ac2":"d6ac1146","chunk-2d22cfae":"205c9309","chunk-471831ce":"0f2d47dd","chunk-adbafe18":"84311f8c","chunk-ce91992c":"39065893","chunk-d9c85796":"3710ea27","chunk-2d0cc056":"a3b5cfde","chunk-2d238284":"2c71513f","chunk-455d53b8":"0ef755a2","chunk-496b9f2c":"8bd993b1","chunk-e3014842":"4d393596","chunk-0af35ffb":"ca594fd2","chunk-2d0f005d":"2c5311b2","chunk-39a6ca5c":"295af82f","chunk-2d0d63c0":"a29b53d0","chunk-2d2086e7":"d39a1ee1","chunk-2d20f748":"e057302f","chunk-2d22fddf":"da06c44a","chunk-0cfb32fb":"86ba1456","chunk-2d0d30e5":"a03ea5fd","chunk-2d229740":"2c901734","chunk-2d0e57e0":"f3cb7dba","chunk-a72a3cd0":"9f66763a","chunk-45b874f3":"3aef3625","chunk-d4c2ff54":"9ea08846","chunk-2d21b2b8":"1473a897","chunk-436928ee":"80d9a0bd","chunk-e80c494c":"88e575a4","chunk-4f302960":"6496a856"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"CongratsInvestment":1,"DiscoverDetailBasket":1,"Login":1,"MarketAnalysis":1,"MarketOverview":1,"Profile":1,"Recover":1,"chunk-1a600e35":1,"chunk-59520b17":1,"chunk-471aa7ba":1,"chunk-503649a8":1,"chunk-5d8e37f8":1,"chunk-5e6f1162":1,"chunk-63bb3991":1,"chunk-a2e7685c":1,"chunk-065ce104":1,"chunk-0b551944":1,"chunk-f6879e22":1,"chunk-031ae681":1,"chunk-9429c060":1,"chunk-44343ce1":1,"chunk-12e41089":1,"chunk-74f8bd2e":1,"chunk-7a900412":1,"chunk-2f0ab176":1,"chunk-19102138":1,"chunk-005088aa":1,"chunk-455d53b8":1,"chunk-496b9f2c":1,"chunk-39a6ca5c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"CompareSymbols":"CompareSymbols","CongratsInvestment":"CongratsInvestment","DiscoverDetailBasket":"DiscoverDetailBasket","Home":"Home","Index":"Index","IndexLogin":"IndexLogin","Login":"Login","MarketAnalysis":"MarketAnalysis","MarketOverview":"MarketOverview","Profile":"Profile","Recover":"Recover","TradeIdeas":"TradeIdeas"}[chunkId]||chunkId) + "." + {"CompareSymbols":"31d6cfe0","CongratsInvestment":"a1931f08","DiscoverDetailBasket":"141c33c2","Home":"31d6cfe0","Index":"31d6cfe0","IndexLogin":"31d6cfe0","Login":"ac033eca","MarketAnalysis":"7c907b55","MarketOverview":"962049ed","Profile":"821d5721","Recover":"9ef14a59","TradeIdeas":"31d6cfe0","chunk-04ccef1c":"31d6cfe0","chunk-0b0b95f7":"31d6cfe0","chunk-1a600e35":"56369e68","chunk-21b8d064":"31d6cfe0","chunk-2d0a3c21":"31d6cfe0","chunk-2d0b1c46":"31d6cfe0","chunk-2d0b304c":"31d6cfe0","chunk-2d0b64c7":"31d6cfe0","chunk-2d0c91f1":"31d6cfe0","chunk-2d0d7303":"31d6cfe0","chunk-2d0dd5e3":"31d6cfe0","chunk-2d0e526b":"31d6cfe0","chunk-2d0e93b3":"31d6cfe0","chunk-2d20f359":"31d6cfe0","chunk-59520b17":"1096adb0","chunk-2d20ff36":"31d6cfe0","chunk-2d210494":"31d6cfe0","chunk-2d217716":"31d6cfe0","chunk-2d228e7f":"31d6cfe0","chunk-3c45ce75":"31d6cfe0","chunk-3d8f3f65":"31d6cfe0","chunk-465b2b0d":"31d6cfe0","chunk-471aa7ba":"315ea26d","chunk-4eab4b4a":"31d6cfe0","chunk-17888276":"31d6cfe0","chunk-503649a8":"a3ebe795","chunk-3bca3622":"31d6cfe0","chunk-4f76de22":"31d6cfe0","chunk-5d8e37f8":"2fd1fb88","chunk-5e6f1162":"49c5cd24","chunk-63bb3991":"02a60d31","chunk-6696b11c":"31d6cfe0","chunk-6fc74062":"31d6cfe0","chunk-7492dbc2":"31d6cfe0","chunk-7730d40d":"31d6cfe0","chunk-a2e7685c":"f9fff0a1","chunk-adf9cb26":"31d6cfe0","chunk-ccbb9b8a":"31d6cfe0","chunk-cf4bb164":"31d6cfe0","chunk-d93d346a":"31d6cfe0","chunk-2d2288e0":"31d6cfe0","chunk-2d230a55":"31d6cfe0","chunk-065ce104":"141c33c2","chunk-0b551944":"f474830e","chunk-2d0a4838":"31d6cfe0","chunk-2d21a700":"31d6cfe0","chunk-46123b5d":"31d6cfe0","chunk-4815502d":"31d6cfe0","chunk-ad71da00":"31d6cfe0","chunk-f6879e22":"99f5278d","chunk-031ae681":"5514e915","chunk-2d0c1d2c":"31d6cfe0","chunk-2d0cbe2b":"31d6cfe0","chunk-2d21d838":"31d6cfe0","chunk-02ed9f8e":"31d6cfe0","chunk-7cfa743a":"31d6cfe0","chunk-f328d256":"31d6cfe0","chunk-2d225840":"31d6cfe0","chunk-9429c060":"2fa4c80b","chunk-0c44d57d":"31d6cfe0","chunk-216771a3":"31d6cfe0","chunk-2d0ab119":"31d6cfe0","chunk-2d0b9672":"31d6cfe0","chunk-44343ce1":"6c17cc78","chunk-2d21d445":"31d6cfe0","chunk-2d21f28d":"31d6cfe0","chunk-35f93194":"31d6cfe0","chunk-12e41089":"e4840a65","chunk-74f8bd2e":"c3a7624a","chunk-7a900412":"f4d0447b","chunk-7c22f149":"31d6cfe0","chunk-9f17c368":"31d6cfe0","chunk-e5267ff6":"31d6cfe0","chunk-2f0ab176":"c9cc5d67","chunk-edcea1fa":"31d6cfe0","chunk-f0151272":"31d6cfe0","chunk-2d0c4c81":"31d6cfe0","chunk-2d238059":"31d6cfe0","chunk-cbbc61f4":"31d6cfe0","chunk-72e93578":"31d6cfe0","chunk-cad577a0":"31d6cfe0","chunk-2d0b9454":"31d6cfe0","chunk-2d0bce02":"31d6cfe0","chunk-16d8b95f":"31d6cfe0","chunk-26e6e08c":"31d6cfe0","chunk-749927d4":"31d6cfe0","chunk-19102138":"5353931f","chunk-56111365":"31d6cfe0","chunk-005088aa":"23564e15","chunk-134d399e":"31d6cfe0","chunk-2d0b30e9":"31d6cfe0","chunk-2d224ac2":"31d6cfe0","chunk-2d22cfae":"31d6cfe0","chunk-471831ce":"31d6cfe0","chunk-adbafe18":"31d6cfe0","chunk-ce91992c":"31d6cfe0","chunk-d9c85796":"31d6cfe0","chunk-2d0cc056":"31d6cfe0","chunk-2d238284":"31d6cfe0","chunk-455d53b8":"65f892bf","chunk-496b9f2c":"9a181b98","chunk-e3014842":"31d6cfe0","chunk-0af35ffb":"31d6cfe0","chunk-2d0f005d":"31d6cfe0","chunk-39a6ca5c":"01182b06","chunk-2d0d63c0":"31d6cfe0","chunk-2d2086e7":"31d6cfe0","chunk-2d20f748":"31d6cfe0","chunk-2d22fddf":"31d6cfe0","chunk-0cfb32fb":"31d6cfe0","chunk-2d0d30e5":"31d6cfe0","chunk-2d229740":"31d6cfe0","chunk-2d0e57e0":"31d6cfe0","chunk-a72a3cd0":"31d6cfe0","chunk-45b874f3":"31d6cfe0","chunk-d4c2ff54":"31d6cfe0","chunk-2d21b2b8":"31d6cfe0","chunk-436928ee":"31d6cfe0","chunk-e80c494c":"31d6cfe0","chunk-4f302960":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
